"us client"
import { checkIsSubscribed, isValidEmail } from '@/helpers/ApiCalls/Waitlist';
import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, useDisclosure } from '@nextui-org/react'
import React, { useEffect } from 'react'

const SubscribeBtn = () => {
    const { isOpen, onOpen, onOpenChange } = useDisclosure();
    const [email, setEmail] = React.useState("")
    const [isSubscribed, setIsSubscribed] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [status, setStatus] = React.useState("Subscribe")
    const [promoViewed, setPromoViewed] = React.useState(false)
    return (
        <>
            <Button className="bg-amber-400 text-black" onPress={onOpen}
            >
                Subscribe
            </Button>
            <Modal isOpen={isOpen} onOpenChange={onOpenChange} isDismissable={false}>
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1">Subscription</ModalHeader>
                            <ModalBody>
                                <p>Sign up & receive a 10% discount on your first purchase</p>
                                <Input
                                    label="Email"
                                    placeholder="Enter your email"
                                    width="100%"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    type='email'
                                    required
                                />
                            </ModalBody>
                            <ModalFooter>
                                <Button className="" variant="light" onPress={onClose}>
                                    Close
                                </Button>
                                <Button className={`${isSubscribed ? "bg-green-500 text-white" : "bg-amber-500"}`}
                                    isLoading={loading}
                                    isDisabled={!isValidEmail(email) || isSubscribed}
                                    onPress={async () => {
                                        await checkIsSubscribed(email, setIsSubscribed, setStatus, setLoading, setPromoViewed);
                                    }}>
                                    {
                                        status
                                    }
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>
        </>
    )
}

export default SubscribeBtn